import { Component, NgZone, OnInit, OnDestroy } from "@angular/core";
import { MenuController, NavController, Platform } from "@ionic/angular";
import { CataleanLocalizationService } from "catalean-localization";
import { environment } from "../environments/environment";
import { Subject, Subscription } from "rxjs";
import { DeviceResourcesService } from "catalean-local-files";
import { CataleanAuthenticationService } from "catalean-authentication";
import { FilterManagerService } from "catalean-provider";
import { Filter } from "catalean-models";
import { App } from "@capacitor/app";

const env = environment;
@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
  styleUrls: ["app.component.scss"],
})
export class AppComponent implements OnInit, OnDestroy {
  public readonly VERSION_PREFIX: string = "v";
  public version: string = "";
  public openMenuSubject = new Subject<void>();
  isMobile: boolean;
  private wasDownloadPaused = false;
  private resumeSub: Subscription;
  private pauseSub: Subscription;

  rootFilterChildren$ = this.filterService.getRootFilterChildren();
  activeFilter$ = this.filterService.getSelectedMetroFilter();
  rootFilter$ = this.filterService.getRootFilter();

  constructor(
    public platform: Platform,
    private menuController: MenuController,
    private localizationService: CataleanLocalizationService,
    private navCtrl: NavController,
    private ngZone: NgZone,
    private deviceResourcesService: DeviceResourcesService,
    private authService: CataleanAuthenticationService,
    private filterService: FilterManagerService,
  ) {
    this.initializeApp();
    const deviceWidth = window.innerWidth;
    if (deviceWidth < 1024) {
      // true for mobile device
      this.isMobile = true;
    } else {
      // false for not mobile device
      this.isMobile = false;
    }
  }

  initializeApp() {
    this.platform.ready().then(() => {
      this.localizationService.setActiveLanguage(env.defaultLocale);
      this.localizationService.AvailableLocales = env.availableLocales;
      // TODO BETTER PERMISSION MANAGMENT
      // could be done with something like a blocking loading page like in smartcommunity
    });
  }

  ngOnDestroy(): void {
    this.resumeSub?.unsubscribe();
    this.pauseSub?.unsubscribe();
  }

  ngOnInit() {
    if (this.platform.is("mobile")) {
      this.platform.ready().then(() => {
        App.getInfo()
          .then(({ version }) => {
            this.version = this.VERSION_PREFIX + version;
          })
          .catch((err) => {
            console.log(err);
            this.version = this.VERSION_PREFIX + environment.version;
          });
      });
    } else {
      this.version = this.VERSION_PREFIX + environment.version;
    }

    if (this.platform.is("cordova")) {
      this.resumeSub = this.platform.resume.subscribe(() => {
        if (!this.wasDownloadPaused) {
          this.ngZone.run(() => {
            this.deviceResourcesService.doDownloadRemoteResources();
          });
        }
      });
      this.pauseSub = this.platform.pause.subscribe(() => {
        this.wasDownloadPaused = this.deviceResourcesService.StopDownload;
        this.deviceResourcesService.StopDownload = true;
      });
    }
  }

  goTo(filter: Filter) {
    this.navCtrl.navigateRoot(["metro"]).then(() => {
      if(!filter['isRoot']) {
        this.filterService.setSelectedMetroFilter(filter);
        this.filterService.setHorizontalFilter(filter.children.find((child) => child.align === "horizontal"));
        this.navCtrl.navigateForward(["product-grid"]);
      }

      window.setTimeout(() => this.menuController.close("catalean-menu"), 600);
      return;
    });
  }

  async logout() {
    this.deviceResourcesService.StopDownload = true;
    await this.authService.logout();
    if (environment.logoutDataRetentionMode === 3) {
      await this.deviceResourcesService.deleteAllAssets();
    }
  }

  onMenuOpen() {
    this.openMenuSubject.next();
  }
}
